import { IGameState } from '../Game/IGameState';
import DateHelper from "Utility/DateHelper";

export default class TimerStateHelper {
    public static setTimer(state: IGameState, timerType: string, time: Date): IGameState {
        const timers: Map<string, Date> = new Map<string, Date>(state.playerState.timers);
        timers.set(timerType, time);
        return {
            ...state,
            playerState: {
                ...state.playerState,
                timers,
            },
        };
    }

    /**
     * Check if the given `timerType` is complete in the game state. Note that a timer may be explicitly set to `null` denoting that the timer is complete.
     * It is unclear why this occurs. Also un-set timers will return `undefined`. If the given `timerType` is either `null` or `undefined` the specified
     * `defaultValue` is returned.
     * // TODO: The `null` and `undefined` behavior might be a bit confusing - should investigate if all use-cases expect this behavior.
     * @param state
     * @param timerType
     * @param duration
     * @param defaultValue Defaults to `true`. This is common behavior for most timers.
     */
    public static isTimerComplete(state: IGameState, timerType: string, duration: number, defaultValue:boolean = true) {
        const startDate = state.playerState.timers.get(timerType);

        // Check timer is elapsed using `DateHelper.now`.
        return DateHelper.isCompleted(startDate, duration, defaultValue);
    }
}
